/*** IMPORTS FROM imports-loader ***/
var define = false;

var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

